
export const common = {
  'call.us': 'Appelez-nous',
  'privacy.policy': 'Politique de confidentialité',
  'select.location': 'Sélectionnez votre emplacement',
  'location.description': 'Choisissez votre emplacement pour appeler le numéro approprié',
  'usa': 'États-Unis',
  'non.usa': 'Hors États-Unis Appel ou WhatsApp',
  'documents.downloads': 'Documents et téléchargements',
  'item': 'Article',
  'value': 'Valeur',
  'price': 'Prix',
  'product': 'Produit',
  'msrp': 'PDSF',
};
